module.exports = __webpack_public_path__ + "media/images/social-share-button/wechat-a11bbee986d0d799349404fbc8cc0524.svg";